import s from "./spinnerLoading.module.scss";
const spinnerLoading = () => <div className={s.loader} />;
export default spinnerLoading;
